"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { SANKAKU_ORDERS, SANKAKU_TYPES } from "@/lib/sankaku-options"
import { useTranslations } from "next-intl"

interface SankakuFilterTabsProps {
  type: string
  order: string
  onTypeChange: (value: string) => void
  onOrderChange: (value: string) => void
}

// Sankaku Complex and Idol Complex share these two real options (pictures or videos, and the order); see lib/sankaku-options.ts.
export function SankakuFilterTabs({ type, order, onTypeChange, onOrderChange }: SankakuFilterTabsProps) {
  const t = useTranslations("sankakuFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[
        { id: "type", label: t("type"), value: type, defaultValue: "all", options: SANKAKU_TYPES.map((value) => ({ value, label: t(value) })) },
        { id: "order", label: t("order"), value: order, defaultValue: "newest", options: SANKAKU_ORDERS.map((value) => ({ value, label: t(value) })) },
      ]}
      onChange={(id, value) => (id === "type" ? onTypeChange(value) : onOrderChange(value))}
    />
  )
}
